document.addEventListener('DOMContentLoaded', () => {

  /* 1 ▸ abort unless merchant chose “slide” */
  if (document.body.dataset.imageReveal !== 'slide') return;

  /* 2 ▸ config */
  const MIN_SIZE = 120;
  const REVEAL_GAP = 0.00;        // seconds between images (after the first)
  const ROW_TOLERANCE = 8;        // px – treat near-equal tops as same row
  const inHeaderFooter = el =>
        el.closest('header') ||
        el.closest('#shopify-section-header') ||
        el.closest('footer') ||
        el.closest('#shopify-section-template--27157239693644__image_banner_hVLf9N') ||
        el.closest('.bsb-image-banner') ||
        el.closest('#shopify-section-sections--27157240217932__176547818331705db6') ||
        el.closest('#shopify-section-footer');

  /* helper: visual row (top) first, then left-to-right */
  const byRowThenCol = (a, b) => {
    const ra = a.target.getBoundingClientRect();
    const rb = b.target.getBoundingClientRect();
    if (Math.abs(ra.top - rb.top) > ROW_TOLERANCE) {
      return ra.top - rb.top;           // row above comes first
    }
    return ra.left - rb.left;           // same row → leftmost first
  };

  /* 3 ▸ ONE IntersectionObserver for every wrapper */
  const io = new IntersectionObserver(entries => {

    let order = 0;                      // resets each tick → first item = 0 s

    entries
      .filter(e => e.isIntersecting)
      .sort(byRowThenCol)
      .forEach(e => {
        const wrap = e.target;
        const node = wrap.querySelector('picture, img');

        gsap.timeline({ delay: order * REVEAL_GAP })
          .set(wrap, { autoAlpha: 2 })
          .from(wrap, { duration: 0.5, xPercent: -100, ease: 'power2.out' })
          .from(node, { duration: 0.5, xPercent: 100, scale: 1.25,
                        delay: -0.5, ease: 'power2.out',
                        onComplete() { node.style.opacity = 1; } });

        order++;                       // next visible item waits longer
        io.unobserve(wrap);            // play only once per image
      });

  }, { threshold: 0.05 });                // fire as soon as 1 px is visible

  /* 4 ▸ enhancer: wrap each image and hand to observer */
  const processed = new WeakSet();

  function enhance(img) {
    if (processed.has(img))                         return;
    if (img.classList.contains('no-slide-reveal'))  return;
    if (inHeaderFooter(img))                        return;
    if (img.offsetWidth < MIN_SIZE &&
        img.offsetHeight < MIN_SIZE)                return;

    processed.add(img);

    const wrap = document.createElement('div');
    wrap.className = 'slide-reveal-wrap';
    img.classList.forEach(c => wrap.classList.add(c));

    const node = img.parentElement.tagName.toLowerCase() === 'picture'
               ? img.parentElement
               : img;
    node.before(wrap);
    wrap.appendChild(node);

    io.observe(wrap);                 // start watching this wrapper
  }

  /* 5 ▸ enhance existing & future images */
  document.querySelectorAll('img').forEach(enhance);

  new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(n => {
        if (n.nodeType !== 1) return;
        if (n.tagName?.toLowerCase() === 'img') enhance(n);
        n.querySelectorAll?.('img').forEach(enhance);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
});